// This file configures the initialization of Sentry on the browser.
// The config you add here will be used whenever a page is visited.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

import * as Sentry from '@sentry/nextjs';

const SENTRY_DSN = process.env.SENTRY_DSN || process.env.NEXT_PUBLIC_SENTRY_DSN;

Sentry.init({
  dsn: SENTRY_DSN || 'https://6de270861c6d488db42435acb38a81a4@o200169.ingest.sentry.io/6151802',
  // Adjust this value in production, or use tracesSampler for greater control
  tracesSampleRate: 0.2,
  allowUrls: ['https://leaked-onlyfans.xyz'],
  // beforeSend(event) {
  //   return null;
  // },
});
